import { render, staticRenderFns } from "./LpSectionForm.vue?vue&type=template&id=8aaf24ac&"
import script from "./LpSectionForm.vue?vue&type=script&lang=js&"
export * from "./LpSectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports